import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  computed,
  input,
  inject,
  signal,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { NgTemplateOutlet } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { TextComponent } from '../text/text.component';

export interface ModalData {
  header?: TemplateRef<unknown>;
  body?: TemplateRef<unknown>;
  footer?: TemplateRef<unknown>;
  title?: string;
}

@Component({
  selector: 'lbt-modal',
  standalone: true,
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, IconComponent, TextComponent, MatDialogClose],
})
export class ModalComponent {
  private injectedData = inject<ModalData | undefined>(MAT_DIALOG_DATA, { optional: true });

  headerTmpl = input<TemplateRef<unknown> | undefined>(undefined);
  bodyTmpl   = input<TemplateRef<unknown> | undefined>(undefined);
  footerTmpl = input<TemplateRef<unknown> | undefined>(undefined);
  title      = input<string | undefined>(undefined);
  showHeader = input<boolean>(true);
  showCloseIcon = input<boolean>(true);
  noDivider = input<boolean>(false);

  private dataSig = signal<ModalData | null | undefined>(this.injectedData);

  readonly header = computed<TemplateRef<unknown> | undefined>(
    () => this.headerTmpl() ?? this.dataSig()?.header
  );
  readonly body = computed<TemplateRef<unknown> | undefined>(
    () => this.bodyTmpl() ?? this.dataSig()?.body
  );
  readonly footer = computed<TemplateRef<unknown> | undefined>(
    () => this.footerTmpl() ?? this.dataSig()?.footer
  );
  readonly modalTitle = computed<string | undefined>(
    () => this.title() ?? this.dataSig()?.title
  );
}
